import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import EndPoints from "../../../Api/EndPoints";

export const fetchApiData = createAsyncThunk(
  "api/fetchData",
  async ({ userId, clientId, clientBranchId }) => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`
      // `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${clientId}&user_id=${userId}&client_branch_id=${clientBranchId}`
    );
    const data = await response.json();
    return data;
  }
);

const landingSlice = createSlice({
  name: "landing",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApiData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default landingSlice.reducer;
